export default __webpack_public_path__ + "static/media/section-about-img-2.7c6f9e73.png";